// store/reducers/MedicineReducer.js
import {
    CONFIRMED_CREATE_MEDICINE_ACTION,
    CONFIRMED_DELETE_MEDICINE_ACTION,
    CONFIRMED_EDIT_MEDICINE_ACTION,
    CONFIRMED_GET_MEDICINES,
  } from "../actions/MedicinesType";
  
  const initialState = {
    medicines: [],
  };
  
  export default function MedicineReducer(state = initialState, action) {
    if (action.type === CONFIRMED_GET_MEDICINES) {
      console.log( "CONFIRMED_GET_MEDICINES", action);  ;
      return {
        ...state,
        medicines: action.payload,
      };
    }
  
    if (action.type === CONFIRMED_CREATE_MEDICINE_ACTION) {
      const medicines = Array.isArray(state.medicines) ? [...state.medicines] : [];
      medicines.push(action.payload);
  
      return {
        ...state,
        medicines,
      };
    }
  
    if (action.type === CONFIRMED_DELETE_MEDICINE_ACTION) {
      const medicines = state.medicines.filter(
        (medicine) => medicine.medicine_id !== action.payload.medicine_id
      );
  
      return {
        ...state,
        medicines,
      };
    }
  
    if (action.type === CONFIRMED_EDIT_MEDICINE_ACTION) {
      const medicines = Array.isArray(state.medicines) ? [...state.medicines] : [];
      const index = medicines.findIndex(
        (medicine) => medicine.medicine_id === action.payload.medicine_id
      );
  
      if (index !== -1) {
        medicines[index] = action.payload;
      }
  
      return {
        ...state,
        medicines,
      };
    }
  
    return state;
  }
  